import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { ICartSimulationView } from '@flexyoo/employee/models';
import { FlexyooNumberPipe } from '@flexyoo/shared/pipes';
import { TranslateModule } from '@ngx-translate/core';

/**
 * "Cart simulation": the first step of the net simulation dialog. It shows how the
 * cart spreads over the budget types and what is left in each of them; the dialog
 * owns the title, the loading states and the buttons.
 */
@Component({
  selector: 'flexyoo-employee-cart-simulation',
  templateUrl: './employee-cart-simulation.component.html',
  styleUrl: './employee-cart-simulation.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateModule, FlexyooNumberPipe],
})
export class EmployeeCartSimulationComponent {
  readonly view = input.required<ICartSimulationView>();
}
